import { render, staticRenderFns } from "./PatientFieldList.vue?vue&type=template&id=5deb65e8&scoped=true"
import script from "./PatientFieldList.vue?vue&type=script&lang=js"
export * from "./PatientFieldList.vue?vue&type=script&lang=js"
import style0 from "./PatientFieldList.vue?vue&type=style&index=0&id=5deb65e8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5deb65e8",
  null
  
)

export default component.exports